import { __decorate } from "tslib";
// import { ifNonNull } from '@web-component-poc/shared';
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import styles from './tab-section.scss.js';
export class TabSection extends CipublicElement {
    constructor() {
        super(...arguments);
        this.isActive = false;
        this.hasHr = false;
    }
    static get styles() {
        return [styles];
    }
    render() {
        return html `<section slot="section" class="tab-pane fade" id="${this.label}" role="tabpanel" aria-labelledby="${this.label}-tab" tabindex="-1"><slot></slot>${this.hasHr ? html `<hr>` : ''}</section>`;
    }
}
__decorate([
    property()
], TabSection.prototype, "label", void 0);
__decorate([
    property({ type: Boolean, attribute: 'active' })
], TabSection.prototype, "isActive", void 0);
__decorate([
    property({ type: Boolean, attribute: 'has-hr' })
], TabSection.prototype, "hasHr", void 0);
//# sourceMappingURL=tab-section.js.map